import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'navigation-customization-dialog',
    templateUrl: './navigation-customization-dialog.component.html',
    styleUrls: ['./navigation-customization-dialog.component.scss'],
    standalone: false
})
export class NavigationCustomizationDialogComponent {

    constructor(public dialogRef: MatDialogRef<NavigationCustomizationDialogComponent>) {
    }

    close(): void {
        this.dialogRef.close();
    }
}
